import React, { useState, useEffect } from "react";
import axios from "axios";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";

function FloorsAndTables({ restaurantId, restaurantName }) {
  const [open, setOpen] = useState([]);
  const [floorData, setFloorData] = useState({
    restaurantId: restaurantId,
    floorName: "",
  });
  const [floors, setFloors] = useState([]);

  const handleClick = () => {
    setOpen(!open);
  };



  return (
    <div style={{ margin: "10px 0 20px 0" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div>
          <label
            class="ml-3 font-normal text-s text-gray-500"
            for="usernameField"
          >
            Restaurant Name
          </label>
          <input
            class="flex items-center h-10 px-4 w-80 bg-gray-200 mt-2 rounded focus:outline-none focus:ring-2 shadow-md"
            type="text"
          />
        </div>

        <div>
          <label
            class="ml-3 font-normal text-s text-gray-500"
            for="usernameField"
          >
            Floor Name
          </label>
          <input
            class="flex items-center h-10 px-4 w-80 bg-gray-200 mt-2 rounded focus:outline-none focus:ring-2 shadow-md"
            type="text"
            onChange={(e) => {
              setFloorData({ ...floorData, floorData: e.target.value });
            }}
          />
        </div>
        <button
          style={{
            textAlign: "left",
            width: "70px",
            padding: "7px",
            marginTop: "30px",
          }}
          class="bg-custom-background text-white"
        >
          Create
        </button>
      </div>

      <div>
        <List>
          <ListItemButton onClick={handleClick}>
            <ListItemText primary="Inbox" />
            {open ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItemButton sx={{ pl: 4 }}>
                <ListItemText primary="Starred" />
              </ListItemButton>
            </List>
            <List component="div" disablePadding>
              <ListItemButton sx={{ pl: 4 }}>
                <ListItemText primary="Starred" />
              </ListItemButton>
            </List>
          </Collapse>
        </List>

        <List>
          <ListItemButton onClick={handleClick}>
            <ListItemText primary="Inbox" />
            {open ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItemButton sx={{ pl: 4 }}>
                <ListItemText primary="Starred" />
              </ListItemButton>
            </List>
            <List component="div" disablePadding>
              <ListItemButton sx={{ pl: 4 }}>
                <ListItemText primary="Starred" />
              </ListItemButton>
            </List>
          </Collapse>
        </List>
      </div>
    </div>
  );
}

export default FloorsAndTables;
